import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './js/App';
import './sass/styles.scss';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);